import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SearchResult } from '@/agent/agent';

interface SearchResultsState {
  results: SearchResult[];
  loading: boolean;
  error: string | null;
}

const initialState: SearchResultsState = {
  results: [],
  loading: false,
  error: null,
};

const searchResultsSlice = createSlice({
  name: 'searchResults',
  initialState,
  reducers: {
    setSearchResults: (state, action: PayloadAction<SearchResult[]>) => {
      state.results = action.payload;
      state.loading = false;
      state.error = null;
    },
    setSearchLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSearchError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearSearchResults: (state) => {
      state.results = [];
      state.loading = false;
      state.error = null;
    },
  },
});

export const { 
  setSearchResults, 
  setSearchLoading, 
  setSearchError, 
  clearSearchResults 
} = searchResultsSlice.actions;

export default searchResultsSlice.reducer;